import React, { lazy /* , useEffect */ } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Loader/Loader';
import Cookies from 'js-cookie';
import { getLoggedInUserData } from '../utils/Helper';

const Auth = lazy(() => import('../screens/Auth'));
const Login = lazy(() => import('../screens/Auth/Login'));
const ForgotPassword = lazy(() => import('../screens/Auth/ForgotPassword'));
const ResetPassword = lazy(() => import('../screens/Auth/ResetPassword'));

const PublicRoute = ({ as: Component, ...props }) => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const [auth, setAuth] = React.useState(false);
  const userCookie = Cookies.get('user');
  const userField = Cookies.get('field');
  let userType = '';
  React.useEffect(() => {
    if (cookies.token && userCookie) {
      const loggedInUserData = getLoggedInUserData();
      userType = (loggedInUserData?.userType && loggedInUserData?.userType?.type) || null;

      if (userType == 'uberadmin') {
        navigate('../app');
      } else {
        if (loggedInUserData?.isChangedPassword == 0 && userField == 'password') {
          navigate('../app/update-password');
          Cookies.set('path', 'update-password');
        } else {
          if (loggedInUserData?.isChangedDetails == 0 && userField == 'password') {
            navigate('../app/update-details');
            Cookies.set('path', 'update-password');
          } else {
            navigate('../app/dashboard');
            Cookies.set('path', 'app/dashboard');
          }
        }
      }
      setAuth(false);
    } else {
      setAuth(true);
      Cookies.remove('path');
    }
  }, [cookies.token, navigate]);

  return auth ? <Component {...props} /> : <Loader />;
};

const authNav = [
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: 'reset-password/:token',
    element: <ResetPassword />,
  },
];

const authRoutes = [
  {
    path: '/',
    element: <PublicRoute as={Auth} />,
    children: authNav,
  },
];

export default authRoutes;
